import type { Components } from 'react-markdown'
import ReactMarkdown from 'react-markdown'

const components: Components = {
  p: ({ children }) => (
    <p className="mb-2 text-sm leading-relaxed last:mb-0">{children}</p>
  ),
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => (
    <ul className="my-2 ml-4 list-disc space-y-1 text-sm last:mb-0">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="my-2 ml-4 list-decimal space-y-1 text-sm last:mb-0">{children}</ol>
  ),
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  a: ({ href, children }) => (
    <a
      href={href}
      className="font-medium text-adventure-600 underline underline-offset-2 hover:text-adventure-700"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  ),
  pre: ({ children }) => (
    <pre className="my-2 overflow-x-auto rounded-md bg-muted p-2 font-mono text-xs">{children}</pre>
  ),
  code: ({ className, children, ...props }) => {
    const isInline = !className
    if (isInline) {
      return (
        <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs" {...props}>
          {children}
        </code>
      )
    }
    return (
      <code className={`font-mono text-xs ${className ?? ''}`} {...props}>
        {children}
      </code>
    )
  },
}

interface RangerMarkdownContentProps {
  content: string
  className?: string
}

export function RangerMarkdownContent({ content, className }: RangerMarkdownContentProps) {
  return (
    <div className={className}>
      <ReactMarkdown components={components}>{content}</ReactMarkdown>
    </div>
  )
}
